export default {
  getCar: (axios, vin, dealerId) =>
    axios.get(`/api/cars/${vin}`, {
      params: { dealerId },
    }),
}
